import React from 'react';
import { Grid, Box, Typography, Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

const WebMetricsInfo = () => {
    const { company } = useSelector((state) => state.company);
    const {
        sum_quality_visits = 0,
        average_bounce_rate = 0,
        average_qvr = 0,
        sum_sessions = 0,
        sum_of_page_views = 0,
        avg_session_duration = 0,
        totalEngagedSession = 0,
        isLoading,
        isGeographyLoading,
        isCostApiLoading,
        isMultiUsageLoading,
    } = useSelector((state) => state.webMatrix);
    const isFinalLoading =
        isLoading ||
        isGeographyLoading ||
        isCostApiLoading ||
        isMultiUsageLoading;
    const renderItems = {
        165: [
            {
                label: 'Sessions',
                value: sum_sessions?.toLocaleString('en-US') || '0',
                visible: true,
            },
            {
                label: 'Quality Visits',
                value: Math.round(
                    Number(sum_quality_visits || 0),
                )?.toLocaleString('en-US'),
                visible: true,
            },
            {
                label: 'Events Per Session',
                value: average_qvr,
                visible: false,
            },
            {
                label: 'Session Duration (Avg.)',
                value: `${avg_session_duration}  sec.`,
                visible: true,
            },
            {
                label: 'Page View',
                value: `${sum_of_page_views}`,
                visible: true,
            },
            {
                label: 'Engaged Sessions',
                value: totalEngagedSession,
                visible: true,
            },
        ],
        61: [
            {
                label: 'Sessions',
                value: sum_sessions?.toLocaleString('en-US') || '0',
                visible: true,
            },
            {
                label: 'Quality Visits',
                value: Math.round(
                    Number(sum_quality_visits || 0),
                )?.toLocaleString('en-US'),
                visible: true,
            },
            {
                label: 'Quality Visits Rate',
                value: `${average_qvr}%`,
                visible: true,
            },
            {
                label: 'Session Duration (Avg.)',
                value: `${avg_session_duration} sec.`,
                visible: true,
            },
            {
                label: 'Page View',
                value: `${sum_of_page_views}`,
                visible: false,
            },
            {
                label: 'Engaged Sessions',
                value: totalEngagedSession,
                visible: true,
            },
        ],
        94: [
            {
                label: 'Sum of Sessions',
                value: sum_sessions?.toLocaleString('en-US') || '0',
                visible: true,
            },
            {
                label: 'Sum of Quality Visits',
                value: Math.round(
                    Number(sum_quality_visits || 0),
                )?.toLocaleString('en-US'),
                visible: true,
            },
            {
                label: 'Average of Quality Visits Rate',
                value: `${average_qvr}%`,
                visible: true,
            },
            {
                label: 'Session Duration (Avg.)',
                value: `${avg_session_duration} sec.`,
                visible: false,
            },
            {
                label: 'Page View',
                value: `${sum_of_page_views}`,
                visible: false,
            },
            {
                label: 'Engaged Sessions',
                value: totalEngagedSession,
                visible: false,
            },
        ],
        150: [
            {
                label: 'Sessions',
                value: sum_sessions?.toLocaleString('en-US') || '0',
                visible: true,
            },
            {
                label: 'Quality Visits',
                value: Math.round(
                    Number(sum_quality_visits || 0),
                )?.toLocaleString('en-US'),
                visible: true,
            },
            {
                label: 'Events Per Session',
                value: average_qvr,
                visible: false,
            },
            {
                label: 'Session Duration (Avg.)',
                value: `${avg_session_duration}  sec.`,
                visible: true,
            },
            {
                label: 'Page View',
                value: `${sum_of_page_views}`,
                visible: true,
            },
        ],
        103: [
            {
                label: 'Sum of Sessions',
                value: sum_sessions?.toLocaleString('en-US') || '0',
                visible: true,
            },
            {
                label: 'Sum of Quality Visits',
                value: Math.round(
                    Number(sum_quality_visits || 0),
                )?.toLocaleString('en-US'),
                visible: true,
            },
            {
                label: 'Average of Quality Visits Rate',
                value: `${average_qvr}%`,
                visible: true,
            },
        ],
        104: [
            {
                label: 'Sum of Sessions',
                value: sum_sessions?.toLocaleString('en-US') || '0',
                visible: true,
            },
            {
                label: 'Sum of Quality Visits',
                value: Math.round(
                    Number(sum_quality_visits || 0),
                )?.toLocaleString('en-US'),
                visible: true,
            },
            {
                label: 'Average of Quality Visits Rate',
                value: `${average_qvr}%`,
                visible: true,
            },
        ],
        105: [
            {
                label: 'Sum of Sessions',
                value: sum_sessions?.toLocaleString('en-US') || '0',
                visible: true,
            },
            {
                label: 'Sum of Quality Visits',
                value: Math.round(
                    Number(sum_quality_visits || 0),
                )?.toLocaleString('en-US'),
                visible: true,
            },
            {
                label: 'Average of Quality Visits Rate',
                value: `${average_qvr}%`,
                visible: true,
            },
        ],
        default: [
            {
                label: 'Sum of Sessions',
                value: sum_sessions?.toLocaleString('en-US') || '0',
                visible: true,
            },
            {
                label: 'Sum of Quality Visits',
                value: Math.round(
                    Number(sum_quality_visits || 0),
                )?.toLocaleString('en-US'),
                visible: true,
            },
            {
                label: 'Average of Quality Visits Rate',
                value: `${average_qvr}%`,
                visible: true,
            },
            {
                label: 'Average of Bounce Rate',
                value: `${avg_session_duration}%`,
                visible: true,
            },
            {
                label: 'Page View',
                value: `${sum_of_page_views} sec.`,
                visible: true,
            },
        ],
    };

    const items = renderItems[company?.id] ?? renderItems.default ?? [];
    const config = items.filter((item) => item.visible);
    const xsValue = 12 / config.length;
    return (
        <Grid container spacing={1}>
            {isFinalLoading
                ? Array.from({ length: config.length }).map((_, index) => (
                      <Grid item key={index} xs={xsValue}>
                          <Box className="padding-16px bg-gray-50 br-16px">
                              <Box className="flex-row-space-between-center gap-8">
                                  <Skeleton
                                      height={18}
                                      variant="text"
                                      width={140}
                                  />
                              </Box>
                              <Box>
                                  <Skeleton
                                      height={32}
                                      variant="text"
                                      width={50}
                                  />
                              </Box>
                          </Box>
                      </Grid>
                  ))
                : config.map((item, index) => (
                      <Grid item key={index} xs={xsValue}>
                          <Box className="padding-16px bg-gray-50 br-16px">
                              <Box className="flex-row-space-between-center gap-8">
                                  <Typography className="text-400fw-14fs-20lh-bg-gray-500">
                                      {item.label}
                                  </Typography>
                              </Box>
                              <Box>
                                  <Typography className="display-sm-semi-bold gray-900 text-center mt-1">
                                      {item.value}
                                  </Typography>
                              </Box>
                          </Box>
                      </Grid>
                  ))}
        </Grid>
    );
};

export default WebMetricsInfo;
